export const SET_CATALOG = (state, payload) => {
  state.catalog = payload
}

export const SET_CATALOG_LOADING = (state, payload) => {
  state.catalogLoading = payload
}

export const SET_INSTANCES = (state, payload) => {
  state.instances = payload
}

export const SET_INSTANCES_LOADING = (state, payload) => {
  state.instancesLoading = payload
}

export const SET_MODULE_FORBIDDEN = (state, payload) => {
  state.moduleForbidden = payload
}
